import { render, staticRenderFns } from "./ordersHistory.vue?vue&type=template&id=9334147e&scoped=true&"
import script from "./ordersHistory.vue?vue&type=script&lang=js&"
export * from "./ordersHistory.vue?vue&type=script&lang=js&"
import style0 from "./ordersHistory.vue?vue&type=style&index=0&id=9334147e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9334147e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VImg,VRow,VSimpleTable})
